// WebAuthn / Passkey management.
import { useEffect, useState } from "react";
import { api } from "../../shared/api/client";
import { PageHeader } from "../../shared/components/PageHeader";
import { Empty, Loading } from "../../shared/components/Empty";
import { Pill } from "../../shared/components/Pill";
import { toast } from "../../shared/stores/toasts";

type Credential = { id: number; nickname: string | null; is_active: boolean; last_used_at: string | null; created_at: string };

export default function PasskeysPage() {
  const [items, setItems] = useState<Credential[] | null>(null);
  const reload = () => api.get<Credential[]>("/auth/webauthn/credentials").then((r) => setItems(r.data));
  useEffect(() => { reload(); }, []);

  const register = async () => {
    try {
      const begin = await api.post("/auth/webauthn/register/begin", { nickname: "" });
      const opts = JSON.parse((begin.data as any).publicKey);
      const cred = await navigator.credentials.create({ publicKey: opts });
      await api.post("/auth/webauthn/register/finish", { credential: cred, nickname: "이 기기" });
      toast.success("패스키 등록됨");
      reload();
    } catch (e: any) {
      toast.error("등록 실패", e?.message);
    }
  };

  const revoke = async (id: number) => {
    if (!confirm("이 패스키를 폐기하시겠습니까?")) return;
    await api.delete(`/auth/webauthn/credentials/${id}`); reload();
  };

  return (
    <>
      <PageHeader title="패스키 관리" subtitle="WebAuthn / Passkey"
        right={<button className="t-btn t-btn-primary" onClick={register}>새 패스키 등록</button>}
      />
      <div className="t-grid cols-1">
        {items === null && <Loading/>}
        {items?.length === 0 && <Empty msg="등록된 패스키가 없습니다"/>}
        <div className="t-card" style={{ padding: 0 }}>
          <div className="t-list" style={{ padding: 16 }}>
            {items?.map((c) => (
              <div key={c.id} className="t-row">
                <span className="title" style={{ flex: 1 }}>{c.nickname || `패스키 #${c.id}`}</span>
                <span className="meta">마지막 사용: {c.last_used_at ? new Date(c.last_used_at).toLocaleString("ko-KR") : "—"}</span>
                <Pill kind={c.is_active ? "ok" : "muted"}>{c.is_active ? "활성" : "폐기됨"}</Pill>
                {c.is_active && <button className="t-btn t-btn-sm" onClick={() => revoke(c.id)}>폐기</button>}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
